import React, {Component} from 'react';
import {Link, withRouter} from 'react-router-dom';
import styles from './Pagination.scss';
import PropTypes from 'prop-types';
import _remove from 'lodash/remove';
import _isEmpty from 'lodash/isEmpty';

class Pagination extends Component {
  render() {
    // This is the limit set by the API.
    const { display } = this.props
    const maxPageLimit = 100;
    let pageParam = 'page';
    let currentPage = 1;
    let lastPage = this.props.totalPages;

    if (lastPage > maxPageLimit) {
      lastPage = maxPageLimit;
    }
    if (this.props.pageParam) pageParam = this.props.pageParam;
    if (lastPage <= 1) return null;
    const findPageParam = new RegExp(pageParam + '=([0-9]+)', 'i');
    const getPage = this.props.location.search.match(findPageParam);
    if (getPage) currentPage = parseInt(getPage[1]);

    const replacePageParam = new RegExp(pageParam);
    let qArr = this.props.location.search.replace('?', '');
    qArr = qArr.split('&');
    _remove(qArr, (item) => {
      let first = item.match(replacePageParam)
      let second = (item == '');
      return (first || second);
    });

    let qs = '?';
    if (!_isEmpty(qArr)) {
      qs = qs + qArr.join('&') + '&';
    }

    let pageRange = this.getPageRange(currentPage, lastPage);

    if (typeof sessionStorage != 'undefined') {
      // we're saving this url to use in the breadcrumbs
      let lsu = sessionStorage.getItem('lastSearchURL');
      let lastSearchURL = this.props.location.pathname + this.props.location.search;
      if (lsu != lastSearchURL) sessionStorage.setItem('lastSearchURL', lastSearchURL);
    }

    const defaultStyle = display === 'alt' ? styles.altPageLink : 'page-link'

    return (
      <nav aria-label="Results Pagination">
        <ul className="d-flex flex-row justify-content-center pagination">
          <li className={`page-item ${(currentPage == 1) ? `${display === 'alt' ? styles.disabled : 'disabled'}` : ''}`}>
            <Link to={qs + pageParam + '=1'} className={`${defaultStyle} ${styles.pagelink}`}>&laquo;</Link>
          </li>
          <li className={`page-item ${(currentPage == 1) ? `${display === 'alt' ? styles.disabled : 'disabled'}` : ''}`}>
            <Link
              to={qs + pageParam + '=' + Math.max(currentPage-1, 1)}
              className={`${defaultStyle} ${styles.pagelink}`}
            >
              &lsaquo;
            </Link>
          </li>
          {pageRange.map((pageNumber, index) =>
            <li key={index} className={`page-item ${(pageNumber == currentPage) ? `${display === 'alt' ? styles.active : 'disabled'}` : ''}`}>
              <Link to={qs + pageParam + '=' + (pageNumber)} className={`${defaultStyle} ${styles.pagelink}`}>
                {pageNumber}
              </Link>
            </li>
          )}

          <li className={`page-item ${(currentPage == lastPage) ? `${display === 'alt' ? styles.disabled : 'disabled'}` : ''}`}>
            <Link
              to={qs + pageParam + '=' + Math.min(currentPage+1, this.props.totalPages)}
              className={`${defaultStyle} ${styles.pagelink}`}
            >
              &rsaquo;
            </Link>
          </li>
          <li className={`page-item ${(currentPage == lastPage) ? `${display === 'alt' ? styles.disabled : 'disabled'}` : ''}`}>
            <Link
              to={qs + pageParam + '=' + (lastPage)}
              className={`${defaultStyle} ${styles.pagelink}`}
            >
              &raquo;
            </Link>
          </li>
        </ul>
      </nav>
    );
  }

  getPageRange = (current, total) => {
    if (total > 10) {
      if (current < 10) {
        return this.getNumberRange(1, 9);
      }
      if (current + 4 > total) {
        return this.getNumberRange(current - 4, total);
      }
      return this.getNumberRange(current - 4, current + 4);
    }
    return this.getNumberRange(1, total);
  }

  getNumberRange = (start, end) => {
    let range = [];
    for (let i = start; i <= end; i++ ) {
      range.push(i);
    }
    return range;
  }
}

Pagination.propTypes = {
  display: PropTypes.oneOf(['default', 'alt']),
  totalPages: PropTypes.number.isRequired,
  pageParam: PropTypes.string,
};

Pagination.defaultProps = {
  display: 'default'
}

export default withRouter(Pagination);
